import { createTheme } from '../theme';

const theme = createTheme({
  components: {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    //@ts-ignore
    Label: {
      defaultProps: {
        variant: 'outlined',
      },
    },
  },
});

export default theme.components;
